module.exports = __webpack_public_path__ + "static/media/head-side.c23809f0.svg";